import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=13ef610b&scoped=true"
import script from "./image-preview.vue?vue&type=script&lang=js"
export * from "./image-preview.vue?vue&type=script&lang=js"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=13ef610b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef610b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ef610b')) {
      api.createRecord('13ef610b', component.options)
    } else {
      api.reload('13ef610b', component.options)
    }
    module.hot.accept("./image-preview.vue?vue&type=template&id=13ef610b&scoped=true", function () {
      api.rerender('13ef610b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/image-preview.vue"
export default component.exports